export default __webpack_public_path__ + "images/b5e19114b0990bab185a2b00d9d32bf0.png";